module.exports = __webpack_public_path__ + "img/drb.c0a31110.svg";